import type { Ctx } from "../../types";
import { Action, invalidate } from "gg-wf-scripts";
import { toast } from "../../toast";

export const cancel_invite: Action<Ctx, { id?: string }> = async (
  { sb },
  data,
  params,
) => {
  const user_id = data.id ?? params.get("id");
  if (!user_id) {
    return { ok: false, error: "Missing id on row record or in URL" };
  }
  const { error } = await sb.functions.invoke(`api/users/${user_id}/invite`, {
    method: "DELETE",
  });
  if (error) {
    toast({ variant: "error", text: "Invite cancel failed. Try again" });
    return { ok: false, error: error.message };
  }
  invalidate("users");
  toast({ variant: "success", text: "Invite cancelled." });
  return { ok: true };
};
